export const MIN_ADULTS = 1;
export const MIN_BEDROOMS = 0;
export const MAX_BEDROOMS = 50;
export const MIN_BATHROOMS = 0;
export const MAX_BATHROOMS = 50;
export const MAX_PLACES = 300;
export const MIN_PRICE = 0;
export const MAX_PRICES = {
    USD: 1000, // US Dollar
    EUR: 1000, // Euro
    GBP: 1000, // British Pound Sterling
    CAD: 1500, // Canadian dollar
    MXN: 20000, // Mexican peso
    ARS: 40000, // Argentine peso
    AUD: 1500, // Australian dollar
    BRL: 4000, // Brazilian Real
    CHF: 1000, // Swiss Franc
    CNY: 7000, // Chinese Yuan
    COP: 3000000, // Columbian Peso
    CZK: 20000, // Czech Koruna
    DKK: 7000, // Danish Krone
    HKD: 8000, // Hong Kong dollar
    HRK: 7000, // Croatian Kuna
    HUF: 300000, // Hungarian Forint
    IDR: 15000000, // Indonesian Rupiah
    ILS: 4000, // Israeli New Sheqel
    INR: 70000, // Indian Rupee
    JPY: 100000, // Japanese Yen
    KRW: 1000000, // South Korean Won
    MYR: 4000, // Malaysian Ringgit
    NOK: 9000, // Norwegian Krone
    NZD: 1500, // New Zealand Dollar
    PLN: 4000, // Polish Zloty
    RUB: 70000, // Russian Ruble
    SEK: 10000, // Swedish Krona
    SGD: 1500, // Singapore dollar
    THB: 30000, // Thai Baht
    TRY: 5000, // Turkish Lira
    ZAR: 15000, // South African Rand
    DEFAULT: 1000,
};

export const MIN_RESULTS_TO_SEARCH = 1;
export const FILTER_OPTION_NIGHTLY_PRICE = 'nightly price';
export const FILTER_OPTION_TOTAL_PRICE = 'total price';
export const NUM_FILTER_PILLS_DISPLAYED = 6;
export const CLEAR_PRICE_FILTERS = [
    'minPrice',
    'maxPrice',
    'minTotalPrice',
    'maxTotalPrice',
    'minNightlyPrice',
    'maxNightlyPrice',
];
export const CLEAR_ROOMS_SPACES_FILTERS = [
    'minBedrooms',
    'minBathrooms',
    'maxBedrooms',
    'maxBathrooms',
];

export const EDAP_LABEL_NIGHTLY_PRICE_INPUT_MAX = 'nightly_price_input_max_';
export const EDAP_LABEL_NIGHTLY_PRICE_INPUT_MIN = 'nightly_price_input_min_';
export const EDAP_LABEL_NIGHTLY_PRICE_SLIDER = 'nightly_price_slider';
export const EDAP_LABEL_TOTAL_PRICE_INPUT_MAX = 'total_price_input_max_';
export const EDAP_LABEL_TOTAL_PRICE_INPUT_MIN = 'total_price_input_min_';
export const EDAP_LABEL_TOTAL_PRICE_SLIDER = 'total_price_slider';
